import React, { Component } from 'react';
import NavigationBar from './NavigationBar';
import { Link } from 'react-router-dom';

class ProcessingPayment extends Component {
  render() {
    return (
        <div>
            <NavigationBar />
            <div className="container col-md-6">
                <h1>Przetwarzanie płatności</h1>
                <div className="alert alert-info">
                    Twoja płatność jest w trakcie przetwarzania.<br />
                    Informacje o zmianie statusu płatności będą przesyłane drogą mailową.
                    <br /><br />
                    Kliknij <b><Link to="/">tutaj</Link></b>, aby wrócić do listy turniejów.
                </div>
            </div>
        </div>
    );
  }
}

export default ProcessingPayment;



// WEBPACK FOOTER //
// ./components/ProcessingPayment.js